<div class="map-wrapper">
  <!-- HEADER -->
  <div class="map-header">
    <small>Dabnet - Harita Entegrasyon</small>
    <dx-button style="margin-left:auto;"
      icon="unselectall"
      stylingMode="contained"
      type="normal"
      (onClick)="layersPanelVisible = !layersPanelVisible"
      hint="Katmanlar"
    ></dx-button>
  </div>

  <!-- HARİTA -->
  <div #mapEl class="map-container"></div>

  <!-- SAĞ PANEL -->
<div class="layers-panel" [class.open]="layersPanelVisible">
    <div class="layers-header">
      <p style="margin:0">Katmanlar</p>
      <dx-button
      icon="close"
      stylingMode="contained"
      type="normal"
      (onClick)="layersPanelVisible = false"></dx-button>
    </div>

    <div class="layers-content">
      <div class="layer-group">
        <div class="group-title">Genel</div>

        <dx-check-box text="Yol"></dx-check-box>
        <dx-check-box text="Ada"></dx-check-box>
        <dx-check-box text="Parsel"></dx-check-box>
      </div>

      <div class="layer-group">
        <div class="group-title">İdari</div>

        <dx-check-box text="Mahalle"></dx-check-box>
        <dx-check-box text="Kapı"></dx-check-box>
      </div>
    </div>
</div>
